import { lumi } from '@/lib/lumi'

export type ContactMessageStatus = 'new' | 'read'

export interface ContactMessage {
  _id: string
  name: string
  email: string
  subject?: string
  message: string
  status: ContactMessageStatus
  creator?: string
  createdAt: string
  updatedAt: string
}

function nowIso() {
  return new Date().toISOString()
}

export function contactStatusLabel(status: ContactMessageStatus | undefined) {
  if (status === 'read') return 'Lida'
  return 'Nova'
}

export async function createContactMessage(payload: {
  name: string
  email: string
  subject: string
  message: string
}) {
  const stamp = nowIso()
  return (await lumi.entities.contact_messages.create({
    name: payload.name.trim(),
    email: payload.email.trim(),
    subject: payload.subject.trim(),
    message: payload.message.trim(),
    status: 'new',
    creator: 'self_service',
    createdAt: stamp,
    updatedAt: stamp,
  })) as ContactMessage
}

export async function fetchAllContactMessages() {
  const { list } = await lumi.entities.contact_messages.list({
    sort: { createdAt: -1 },
    limit: 400,
  })
  return (list ?? []) as ContactMessage[]
}

export async function markContactMessageRead(id: string) {
  if (typeof id !== 'string' || id === '[object Object]') {
    throw new Error('ID inválido')
  }
  return (await lumi.entities.contact_messages.update(id, {
    status: 'read',
    updatedAt: nowIso(),
  })) as ContactMessage
}
